<template>
  <div class="mb-5">
    <button class="btn btn-primary" @click.prevent="toggleAddModal">
      <i class="fas fa-plus fs-1"></i>
      <span v-if="title" class="fs-6 fw-semibold"> {{ title }} </span>
    </button>
  </div>
  <div class="row d-flex">
    <div v-for="(data, index) in model" :key="index" class="col-12 col-md-4 col-lg-4 mb-3">
      <Card class="h-100">
        <div class="row h-100 d-flex justify-content-center align-items-center bg-light rounded-2 py-2" style="width: 98% !important;">
          <div class="col">
            <div class="symbol symbol-30px symbol-circle">
              <div v-if="data[getKey(0)]" class="symbol-label bg-primary text-white text-uppercase"> {{ `${data[getKey(0)]?.toString()[0]}${data[getKey(1)]?.toString()[0]}` }}  </div>
            </div>
          </div>
          <div class="col-6 mt-2">
            <p>{{ data[getKey(0)] }} {{ data[getKey(1)] }}</p>
          </div>
          <div class="col-2">
            <div class="d-flex">
              <button @click.prevent="editData(index)" class="btn btn-sm btn-icon btn-outline-primary me-2">
                <i class="fa fa-pen "></i>
              </button>
              <button @click.prevent="deleteData(index)" class="btn btn-sm btn-icon btn-outline-danger">
                <i class="fa fa-trash"></i>
              </button>
            </div>
          </div>
        </div>
      </Card>
    </div>
  </div>
  <div class="modal fade" :id="'addDataModal'+step" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="modal-title">{{title}}</h2>
          <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click.prevent="toggleAddModal">
                <span class="svg-icon svg-icon-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                          fill="currentColor" />
                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                          fill="currentColor" />
                  </svg>
                </span>
          </div>
        </div>
        <form @submit.prevent="addData">
          <div class="modal-body">
            <div class="row">
              <FormField
                  v-for="field in fields"
                  :key="step + field.id"
                  :form-data="field"
                  v-model="formData.data"
                  :parent-id="'addDataModal'+step"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-outline btn-outline-primary btn-active-light-primary" @click.prevent="toggleAddModal" type="reset">
              {{ $t('button.cancel') }}
            </button>
            <button class="btn btn-primary" type="submit">
              {{ $t('button.save') }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>

import Card from "@/components/Card.vue";
import FormField from "@/components/Form/FormField.vue";
import {computed, defineProps, reactive, ref} from "vue";

const model = defineModel({ default: () => [] })

const props = defineProps({
  step: { type: String },
  title: { type: String },
  fields: {type: Array, required: true},
})

const isEdit = ref(false)
const editDataIndex = ref(null)
const formData = reactive({data: {}})
const fieldKeys = computed(() => props.fields.map(el => el.name+'_'+el.id))

const toggleAddModal = () => {
  $('#addDataModal'+props.step).modal('toggle')
}

const addData = () => {
  if(isEdit.value) {
    const data = [...model.value];
    data.splice(editDataIndex, 1);
    data.push({...formData.data})
    model.value = data
    resetForm()
    toggleAddModal()
  }else {
    const addValue = [...model.value];
    addValue.push({...formData.data})
    model.value = addValue
    resetForm()
    toggleAddModal()
  }
}

const resetForm = () => {
  formData.data = {}
  isEdit.value = false
}

const getKey = (number) => {
  return fieldKeys.value[number]
}

const editData = (index) => {
  isEdit.value = true
  editDataIndex.value = index
  formData.data = {...model.value[index]}
  toggleAddModal()
}

const deleteData = (index) => {
  const data = [...model.value];
  data.splice(index, 1);
  model.value = data;
}

</script>

<style scoped>
.selector {
  border: 1px dashed gray;
  border-radius: 15px;
  background-color: rgba(25, 54, 98, 0.05);
  min-height: 115px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 100% !important;
}

.selector:hover {
  background-color: rgba(25, 54, 98, 0.10);
}

.selector span {
  color: rgba(25, 54, 98, 0.75);
}


</style>